<template>
  <section class="purchase-invoice-list">
    <snowflake-search-list context="purchase-invoice" :service="purchaseInvoiceService" :page-size="20" fixed-operations
      action-title="Importar XMLs" action-icon="el-icon-upload2" :action-link-to="importLink" details-icon="el-icon-view">
      <template slot="tableRows">

        <el-table-column prop="issuedAt" label="Emissão" width="110" sortable>
          <template slot-scope="scope">{{ formatDate(scope.row.issuedAt) }}</template>
        </el-table-column>

        <el-table-column prop="number" label="Número" width="110" sortable></el-table-column>

        <el-table-column prop="issuerName" label="Fornecedor" :show-overflow-tooltip="true" sortable></el-table-column>

        <el-table-column label="CNPJ" width="170">
          <template slot-scope="scope">{{ formatDocument(scope.row.issuerDocument) }}</template>
        </el-table-column>

        <el-table-column prop="totalAmount" label="Valor total" width="140" align="right" sortable>
          <template slot-scope="scope">{{ formatCurrency(scope.row.totals.totalAmount) }}</template>
        </el-table-column>

        <el-table-column prop="status" label="Situação" width="140" sortable>
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.status === 'CANCELLED' ? 'danger' : 'success'">
              {{ statusLabels[scope.row.status] }}
            </el-tag>
            <el-tag v-if="scope.row.recipientManifestation === 'UNKNOWN_OPERATION'" size="mini" type="warning">
              {{ manifestationLabels.UNKNOWN_OPERATION }}
            </el-tag>
          </template>
        </el-table-column>

      </template>
    </snowflake-search-list>
  </section>
</template>

<script>
import PurchaseInvoiceService from '@/services/fiscal/PurchaseInvoiceService';
import SnowflakeSearchList from '@/components/list/SearchList.vue';
import {
  formatCurrency, formatDate, formatDocument, manifestationLabels, statusLabels,
} from './labels';

export default {
  name: 'purchase-invoice-list',
  components: {
    SnowflakeSearchList,
  },
  data() {
    return {
      purchaseInvoiceService: PurchaseInvoiceService,
      statusLabels,
      manifestationLabels,
    };
  },
  methods: {
    formatCurrency,
    formatDate,
    formatDocument,
    importLink() {
      return { name: 'purchase-invoice-import' };
    },
  },
};
</script>
